import { render, staticRenderFns } from "./SkuList.vue?vue&type=template&id=6b973044&scoped=true"
import script from "./SkuList.vue?vue&type=script&lang=js"
export * from "./SkuList.vue?vue&type=script&lang=js"
import style0 from "./SkuList.vue?vue&type=style&index=0&id=6b973044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b973044",
  null
  
)

export default component.exports